var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { IsNotEmpty, IsOptional, IsString, ValidateNested, } from 'class-validator';
import * as Site from './site.js';
export class CreateInputDto {
    //'', null, undefined, void not passed
    name;
    initialWorkspace;
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateInputDto.prototype, "name", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => Site.CreateInputDto),
    __metadata("design:type", Object)
], CreateInputDto.prototype, "initialWorkspace", void 0);
export class UpdateInputDto {
    //'' not passed
    name;
}
__decorate([
    IsOptional(),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", Object)
], UpdateInputDto.prototype, "name", void 0);
//# sourceMappingURL=advertiser-account.js.map